import { Validators } from '@angular/forms';

export class FormInfo {
  validators: Validators;
  disabled: boolean;
  constructor(required: boolean, validator: Validators) {
    this.disabled = required;
    this.validators = validator;
  }
}
export const CGCHARGEVALIDATORS = {
    CREATE: new Map<string, FormInfo>([
      ['id', new FormInfo(false, [])],
      ['dCreation', new FormInfo(true, [])],
      ['idCreateur', new FormInfo(true, [])],
      ['dModification', new FormInfo(true, [])],
      ['idModifieur', new FormInfo(true, [])],
      ['dDesactivation', new FormInfo(true, [])],
      ['code', new FormInfo(false, [Validators.required, Validators.maxLength(8)])],
      ['libelle', new FormInfo(false, [Validators.required, Validators.maxLength(30)])],
      ['idSociete', new FormInfo(false, [])]

    ]),
    EDIT: new Map<string, FormInfo>([
        ['id', new FormInfo(false, [])],
        ['dCreation', new FormInfo(true, [])],
        ['idCreateur', new FormInfo(true, [])],
        ['dModification', new FormInfo(true, [])],
        ['idModifieur', new FormInfo(true, [])],
        ['dDesactivation', new FormInfo(true, [])],
        ['code', new FormInfo(true, [Validators.required, Validators.maxLength(8)])],
        ['libelle', new FormInfo(false, [Validators.required, Validators.maxLength(30)])],
        ['idSociete', new FormInfo(false, [])]
    ]),
    VISUALIZE: new Map<string, FormInfo>([
        ['id', new FormInfo(false, [])],
        ['dCreation', new FormInfo(true, [])],
        ['idCreateur', new FormInfo(true, [])],
        ['dModification', new FormInfo(true, [])],
        ['idModifieur', new FormInfo(true, [])],
        ['dDesactivation', new FormInfo(true, [])],
        ['code', new FormInfo(false, [Validators.required, Validators.maxLength(8)])],
        ['libelle', new FormInfo(false, [Validators.required, Validators.maxLength(30)])],
        ['idSociete', new FormInfo(false, [])]
    ])
  };
